import { useState, useEffect } from 'react';

/**
 * コンパクトレイアウト判定フック
 * 縦幅（高さ）が狭いときにコンパクトレイアウトを適用
 * Pixel 7 横持ち（915x412）を想定し、高さ 500px 未満で判定
 */
export function useIsMobile(): boolean {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const checkCompact = () => {
      setIsCompact(window.innerHeight < 500);
    };

    // 初期チェック
    checkCompact();

    // リサイズ時に再チェック
    window.addEventListener('resize', checkCompact);
    return () => window.removeEventListener('resize', checkCompact);
  }, []);

  return isCompact;
}
